import { createLink } from "@tanstack/react-router"
import type { ComponentProps } from "react"

const Link = createLink((props: ComponentProps<"a">) => <a {...props} />)

export default Link
